export const products = [
    {
        image: 'https://detail.tmall.com/item.htm?id=707089975639',
        productName: '文化衫t恤工作服班服纯棉短袖宽松圆领定做印字'
    },
    {
        image: 'https://img.alicdn.com/bao/uploaded/i1/837350944/O1CN01Wp2zqu1IqOelkDezJ_!!0-item_pic.jpg',
        productName: '裤子夏季新款韩版潮流士薄款修身弹力大码棉休闲裤夏天长裤'
    },
    {
        image: 'https://img.alicdn.com/bao/uploaded/i1/837350944/O1CN01ig7NMj1IqOgk6Qnhl_!!837350944.jpg',
        productName: "男士牛仔裤裤子直筒潮流薄款弹力夏季"
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_6f29ac1e22d63f6c105403c96e8af284_sx_644528_www800-800',
        productName: '新款百搭厚底帆布鞋小众设计低帮板鞋2023夏季防滑透气暴款小白鞋'
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_9940576f148cf75a6e810eea3758b674_sx_456955_www800-800',
        productName: '新款春夏宝藏鞋子透气百搭小白鞋休闲轻便平底休闲鞋2023潮流女鞋'
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_4fb4cc36b4164593bca6ab038bd45aa5_sx_457559_www800-800',
        productName: '新款内增高老爹鞋休闲百搭时尚小白鞋2023年夏季网面透气运动鞋'
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_e6942ecc6a7c04ff71d824d31bf6fa76_sx_49012_www657-657',
        productName: '新款透气百搭网面鞋2023年夏季软底防滑休闲跑步鞋轻便时尚系带鞋'
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_93f34173db8f76fab28a5867e83a8eb6_sx_374590_www800-800',
        productName: '新款英伦风小皮鞋一脚蹬软皮休闲鞋明星同款2023透气百搭时尚单鞋'
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_56efff70fad4dbdb108fa50203dc28bd_sx_536885_www800-800',
        productName: '2023新款网面透气休闲阿甘鞋夏季百搭运动鞋轻便耐磨低帮软底女鞋'
    },
    {
        image:'https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wJSRMBh_m_91fec189f81cb707dbfd263a5818e68a_sx_376516_www800-800',
        productName: '新款松糕底帆布鞋百搭魔术贴系带小白鞋2023夏季透气运动休闲板鞋'
    },
]